module.exports = __webpack_public_path__ + "static/img/12.88e1a2b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/sp/12.png
// module id = 6Ufa
// module chunks = 0